import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton-card',
    template: `
        <div class="skeleton-card-grid" [style.gridTemplateColumns]="gridColumns">
            <div *ngFor="let card of cardList" class="sk-card" [ngClass]="'sk-card--' + type">
                <!-- Top Row: Icon + Badge / Action -->
                <div class="sk-card-top">
                    <div class="sk-card-icon skeleton-shimmer"></div>
                    <div class="sk-card-pill skeleton-shimmer"></div>
                </div>

                <!-- Middle: Title + Subtitle Lines -->
                <div class="sk-card-body">
                    <div class="sk-card-title skeleton-shimmer"></div>
                    <div class="sk-card-subtitle skeleton-shimmer"></div>
                </div>

                <!-- Optional Progress Bar or Value Stack -->
                <div class="sk-card-footer" *ngIf="type === 'metric' || type === 'showcase'">
                    <div class="sk-card-val skeleton-shimmer"></div>
                    <div class="sk-card-bar skeleton-shimmer" *ngIf="showProgressBar"></div>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .skeleton-card-grid {
            display: grid;
            gap: 1.25rem;
            width: 100%;
        }

        .sk-card {
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            padding: 1.25rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 1.15rem;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
            min-height: 140px;

            :host-context(.dark) & {
                background: #0f172a;
                border-color: #334155;
            }
        }

        .sk-card-top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .sk-card-icon {
                width: 42px;
                height: 42px;
                border-radius: 10px;
            }

            .sk-card-pill {
                width: 65px;
                height: 22px;
                border-radius: 6px;
            }
        }

        .sk-card-body {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;

            .sk-card-title {
                height: 16px;
                width: 75%;
                border-radius: 4px;
            }

            .sk-card-subtitle {
                height: 11px;
                width: 50%;
                border-radius: 4px;
            }
        }

        .sk-card-footer {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            border-top: 1px solid #f1f5f9;
            padding-top: 0.75rem;

            .sk-card-val {
                height: 18px;
                width: 40%;
                border-radius: 4px;
            }

            .sk-card-bar {
                height: 6px;
                width: 100%;
                border-radius: 3px;
            }

            :host-context(.dark) & {
                border-color: #1e293b;
            }
        }
    `]
})
export class SkeletonCardComponent {
    @Input() count: number = 4;
    @Input() columns: number = 4;
    @Input() type: 'standard' | 'metric' | 'showcase' = 'metric';
    @Input() showProgressBar: boolean = true;

    get cardList(): number[] {
        return Array.from({ length: this.count }, (_, i) => i);
    }

    get gridColumns(): string {
        return `repeat(${this.columns}, minmax(0, 1fr))`;
    }
}
